import {createActions} from 'redux-actions';
import fetchJson, {postJson, putJson} from '../fetchJson';
import {push} from 'connected-react-router';
import handleError from '../handleError';
import ReactGA from 'react-ga';

const actions = createActions(
	'REVIEWS_LOADED',
	'REVIEWS_NEW_OPEN',
	'REVIEWS_NEW_SAVED',
	'REVIEWS_NEW_CANCELLED',
	'REVIEWS_NEW_UPDATE',
	'REVIEWS_EDIT_OPEN'
);

export const retrieveReviews = uuid => dispatch => {
	fetchJson(`/api/providers/${uuid}/reviews`)
		.then(reviews => dispatch(actions.reviewsLoaded(reviews)))
		.catch(handleError(dispatch));
};

export const persistReview = () => (dispatch, getState) => {
	const session = getState().session;

	ReactGA.event({
		category: 'Reviews',
		action: 'Edit'
	});

	// send to different endpoint if editing existing review
	if (getState().reviews.editingReview) {
		putJson(`/api/providers/${getState().profile.uuid}/reviews`, getState().reviews.editing).catch(
			handleError(dispatch)
		);
	} else {
		postJson(`/api/providers/${getState().profile.uuid}/reviews`, getState().reviews.editing).catch(
			handleError(dispatch)
		);
	}

	dispatch(actions.reviewsNewSaved(session.current.provider));
};

export default {
	...actions,
	retrieveReviews,
	persistReview
};



// WEBPACK FOOTER //
// ./src/profile/reviews.actions.js